import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Department } from '@masar/common/models';
import { permissionList } from '@masar/common/constants';

@Component({
    selector: 'app-department-link',
    templateUrl: './department-link.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class DepartmentLinkComponent {
    @Input() public item: Department;
    public permissionList = permissionList;
}
